import { useMutation, UseMutationOptions, MutateFunction } from 'react-query'
import { connector } from '../api/connector'

export function useContrastMutation<TResponse, TError, TVariables>(
  mutationFn: MutateFunction<TResponse, TError, TVariables>,
  options: UseMutationOptions<TResponse, TError, TVariables> = {}
) {
  const mutation = (args: TVariables) => mutationFn.call({ connector }, args)
  return useMutation<TResponse, TError, TVariables>(mutation, options)
}
